<template>
    <div class="modal fade" :id="'updateParticipantModal' + _uid" role="dialog" aria-labelledby="updateParticipantModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateParticipantModalLabel">{{$t('registers.participants.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <participant-edit-card v-model="model"
                                           v-if="showEditor"
                                           @save="onSave"
                                           @cancel="onCancel"
                                           @onNomEditModalClose="onNomEditModalClose">
                    </participant-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Participant } from '@/models/models';
    import ParticipantEditCard from './ParticipantEditCard';

    export default {
        components: {
            ParticipantEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
            profileManagement: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new Participant(),
            };
        },
        methods: {
            onClose(e, fromBtn) {
                if ((e && e.target.id === `updateParticipantModal${this._uid}`) || fromBtn === true) {
                    this.$emit('onClose', { ...this.model });
                    this.model = new Participant();
                    this.$validator.reset();
                } else {
                    $(this.$el).focus();
                }

                this.showEditor = false;
                // this.$emit('onClose', { ...this.model });
                // this.model = new Participant();
                // this.$validator.reset();
            },
            hide(e) {
                $('#updateParticipantModal' + this._uid).modal('hide');
                // $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onSave', model);
                this.onClose(null, true);
            },
            onCancel() {
                this.onClose(null, true);
            },
            onNomEditModalClose() {}
        },
        mounted() {
            // add modal close listener
            $('#updateParticipantModal' + this._uid).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $('#updateParticipantModal' + this._uid).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Participant(this.value);
                    this.showEditor = true;
                    $('#updateParticipantModal' + this._uid).modal('show');
                } else {
                    $('#updateParticipantModal' + this._uid).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
